import { useMemo } from "react";
import { Link } from "react-router-dom";
import { Stack } from "@buildo/bento-design-system";
import { Event } from "../types";

interface FeaturedEventsTileProps {
  events: Event[];
  loading?: boolean;
}

const FEATURED_LIMIT = 5;

function sortEventsByRecent(events: Event[]): Event[] {
  return [...events].sort((a, b) => {
    if (a.date && b.date) {
      return b.date.localeCompare(a.date);
    }
    if (a.date) {
      return -1;
    }
    if (b.date) {
      return 1;
    }
    return Number(b.id) - Number(a.id);
  });
}

function FeaturedEventsTile({ events, loading }: FeaturedEventsTileProps) {
  const featuredEvents = useMemo(
    () => sortEventsByRecent(events).slice(0, FEATURED_LIMIT),
    [events]
  );

  if (loading) {
    return (
      <section className="bentolio-card bentolio-area-work">
        <p className="body-text">Loading events...</p>
      </section>
    );
  }

  const [withPhotos, rest] = [featuredEvents.slice(0, 2), featuredEvents.slice(2)];

  return (
    <section className="bentolio-card bentolio-area-work">
      <Stack space={16}>
        {withPhotos.map((event, index) => (
          <Link
            key={event.id}
            to={`/events/${event.id}`}
            className={index > 0 ? "event-row" : undefined}
          >
            <div className="featured-event-header">
              <h2 className="h1-text">{event.title}</h2>
              <span aria-hidden>↗</span>
            </div>
            {event.heroImageUrl && (
              <img
                src={event.heroImageUrl}
                alt={event.title}
                className="featured-event-image"
              />
            )}
          </Link>
        ))}
        {rest.map((event) => (
          <Link key={event.id} to={`/events/${event.id}`} className="event-row">
            <h3 className="h1-text">{event.title}</h3>
          </Link>
        ))}
      </Stack>
    </section>
  );
}

export default FeaturedEventsTile;
